import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsEquipmentInstanceStatus, PmsEquipmentInstanceStatus } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsEquipmentInstanceStatus>
    useData={usePmsEquipmentInstanceStatus}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
